<template>
    <mdb-container v-if="info" fluid class="bg-white py-3">
        <h1 class="mb-5"> {{ info[0].title }}</h1>
        <div style="float: left;" class="mr-4 mb-4" v-if="info[0].image[0]">
            <img class="mw-100" :src="'https://strapi.tys.uz' + info[0].image[0].url">
        </div>
        <VueShowdown :markdown=info[0].text />
    </mdb-container>
</template>

<script>

    import axios from 'axios';
    import {
        mdbContainer,
    } from "mdbvue";
    import store from "../../store";

    export default {
        name: "smk",
        components: {
            mdbContainer,
        },
        data() {
            return {
                slug: this.$route.params.slug,
                info: null
            }
        },
        watch: {
            $route() {
                axios.get(process.env.VUE_APP_CONTENT_URL + '/infos?template=' + this.$route.params.slug + '&token=' + process.env.VUE_APP_CONTENT_REST_TOKEN, {headers:{Authorization: ''}})
                    .then(response => {
                        this.info = response.data
                        store.commit('setBreadcrumbs',['СМК']);
                    });
            }
        },
        mounted() {
            axios.get(process.env.VUE_APP_CONTENT_URL + '/infos?template=' + this.$route.params.slug + '&token=' + process.env.VUE_APP_CONTENT_REST_TOKEN, {headers:{Authorization: ''}})
                .then(response => {
                  this.info = response.data
                  console.log(this.info)
                  store.commit('setBreadcrumbs',['СМК']);
                });
        },
    }
</script>

<style scoped>

</style>